import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=0417fabe"
import script from "./RealEstate.vue?vue&type=script&lang=js"
export * from "./RealEstate.vue?vue&type=script&lang=js"
import style0 from "./RealEstate.vue?vue&type=style&index=0&id=0417fabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports